// TVTool B7a (spec §9.4) — on app open, refetch the published list and bring the training cache in step: a video
// whose published version changed is re-downloaded and the old file removed; new videos arrive in the background.
// Mounted once in App.tsx beside the audio-pack prefetch; it renders nothing. useTrainingLibrary does the work
// (and the kill switch leaves it idle).
import { useTrainingLibrary } from '@/features/help/hooks/useTrainingLibrary';

export const TrainingSync = () => {
  useTrainingLibrary(null);
  return null;
};
